import type { RouteObject } from 'react-router';
import { AppErrorLayout, AppLayout, HomePage, LoadingScreen } from './shared/layout';

/**
 * Route table. Each feature is a lazy chunk; the home screen is eager. The layout's error boundary
 * (`AppErrorLayout`) draws the error screen inside the app frame (header, tab bar), so an unknown
 * path (404) or a screen that throws keeps the navigation.
 */
export const routes: RouteObject[] = [
  {
    path: '/',
    Component: AppLayout,
    ErrorBoundary: AppErrorLayout,
    HydrateFallback: LoadingScreen,
    children: [
      { index: true, Component: HomePage },
      {
        path: 'drive',
        lazy: async () => ({ Component: (await import('./features/drive')).DriveRoute }),
      },
      {
        path: 'exam',
        lazy: async () => ({ Component: (await import('./features/exam')).ExamRoute }),
      },
      {
        path: 'ly-thuyet',
        lazy: async () => ({ Component: (await import('./features/theory')).TheoryRoute }),
      },
      {
        path: 'thi-thu',
        lazy: async () => ({ Component: (await import('./features/exam-hub')).ExamHubRoute }),
      },
      {
        path: 'sa-hinh',
        lazy: async () => ({
          Component: (await import('./features/practice-hub')).PracticeHubRoute,
        }),
      },
      {
        path: 'toi',
        lazy: async () => ({ Component: (await import('./features/me')).MeRoute }),
      },
      {
        path: 'lam-quen',
        lazy: async () => ({
          Component: (await import('./features/onboarding')).OnboardingRoute,
        }),
      },
      {
        path: 'lich-su',
        lazy: async () => ({ Component: (await import('./features/history')).HistoryRoute }),
      },
      {
        path: 'lich-su/:id',
        lazy: async () => ({ Component: (await import('./features/history')).HistoryRoute }),
      },
      {
        path: 'dang-nhap',
        lazy: async () => ({ Component: (await import('./features/auth')).AuthRoute }),
      },
      {
        path: 'tai-khoan',
        lazy: async () => ({
          Component: (await import('./features/auth/account')).AccountRoute,
        }),
      },
    ],
  },
];
